import { createUseStyles } from 'react-jss'
import WidgetFocus from '@/components/__new/WidgetFocus'
import style from './style'

const useStyles = createUseStyles(style)

function DetailList({ title, items }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <WidgetFocus
        data={{
          use_carousel: false,
          use_details: true,
          details: {
            title,
            items: items.map((item) => ({
              ...item,
              abstract: item.paragraph,
            })),
          },
        }}
      />
    </div>
  )
}

export default DetailList
